import "./App.css";
import { Header, HomeCase, NavBar, Copyright } from "./components";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Faqs, Pricing, SignIn, SignUp } from "./pages";

function App() {
  return (
    <BrowserRouter>
      <div className={`grad-sec overflow-x-hidden`}>
        <NavBar />
        <Routes>
          <Route
            exact
            path="/"
            element={
              <div>
                <Header />
                <HomeCase />
              </div>
            }
          />
          <Route path="/signin" element={<SignIn />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/faqs" element={<Faqs />} />
          <Route path="/price" element={<Pricing />} />
        </Routes>
        <Copyright />
      </div>
    </BrowserRouter>
  );
}

export default App;
